import { Component, OnInit, OnDestroy } from "@angular/core";
import { MenuController } from "@ionic/angular";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "../auth.service";
import { removeInitScreen } from "src/app/_helpers/appLoading";

@Component({
  selector: "app-confirm-register",
  templateUrl: "./confirm-register.page.html",
  styleUrls: [
    "./confirm-register.page.scss",
    "./../../../_styles/ion-grid-box.scss",
  ],
})
export class ConfirmRegisterPage implements OnInit, OnDestroy {
  activated: boolean = false;
  iconSrc: string;
  key: string;
  loading: boolean = true;

  constructor(
    private menu: MenuController,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {
    this.route.queryParams.subscribe((params) => {
      this.authService.confirmRegistration(params["key"]).subscribe(
        () => {
          (this.activated = true),
            (this.loading = false),
            (this.iconSrc = "../../../../assets/icons/activated-account.svg");
        },
        (error) => {
          (this.activated = false),
            (this.loading = false),
            (this.iconSrc = "../../../../assets/icons/not-activated.svg");
        }
      );
    });
  }

  ngOnInit() {
    this.menu.enable(false);
    removeInitScreen();
  }

  ngOnDestroy() {
    this.menu.enable(true);
  }
}
